/** Opaque persisted badge colors need a foreground, not an assumed white label.
 * Keep the stored hue; invalid/non-hex legacy values get a render-only safe pair.
 * Black/white maximum contrast is >=4.58:1 for every opaque sRGB color.
 */
export function badgeColors(value: string | null | undefined) {
  const raw = (value || '').trim();
  const hex = /^#[\da-f]{6}$/i.test(raw) ? raw : /^#[\da-f]{3}$/i.test(raw)
    ? '#' + [...raw.slice(1)].map(c => c + c).join('') : '#2563eb';
  const rgb = [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16) / 255);
  const linear = rgb.map(v => v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4);
  const luminance = linear[0] * 0.2126 + linear[1] * 0.7152 + linear[2] * 0.0722;
  return { backgroundColor: hex, color: (luminance + 0.05) / 0.05 >= 1.05 / (luminance + 0.05) ? '#000000' : '#ffffff' };
}
